import useAutoLogout from "src/hooks/useAutoLogout";
import useAuth from 'src/hooks/useAuth';
import { useHistory } from 'react-router-dom';

const InActivityWatcher = () => {
  const { logout } = useAuth();
  const history = useHistory();
  
  const autoLogout = async () => {
    console.log("Auto logout triggered inside Provider");
    await logout();
    history.push("/login");
  };

  useAutoLogout(autoLogout);
  return null;
};

export default InActivityWatcher
